import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { layout: "main" },
    component: () => import("../views/Home"),
  },
  {
    path: "/news",
    name: "News All",
    meta: { layout: "main" },
    component: () => import("../views/News"),
  },
  {
    path: "/courses",
    name: "Courses",
    meta: { layout: "main" },
    component: () => import("../views/course/CourseAll"),
  },
  {
    path: "/course/:id",
    name: "Course",
    meta: { layout: "main" },
    component: () => import("../views/course/CoursesSingle"),
  },
  {
    path: "/lessons/:id",
    meta: { layout: "lesson", requiresAuth: true },
    component: () => import("../views/course/Lesson1.vue"),
  },
  {
    path: "/quiz/:slug",
    meta: { layout: "lesson", requiresAuth: true },
    component: () => import("../views/course/Quiz1.vue"),
  },
  {
    path: "/final-quiz/:slug",
    meta: { layout: "lesson", requiresAuth: true },
    component: () => import("../views/course/FinalQuiz.vue"),
  },
  {
    path: "/login",
    name: "Логин",
    meta: { layout: "auth" },
    component: () => import("../views/auth/Login"),
  },
  // Registration disabled - self-registration not allowed for employee training
  // {
  //     path: '/registration',
  //     name: 'Регистрация',
  //     meta: {layout: "auth"},
  //     component: () => import('../views/auth/Registration')
  // },
  // {
  //     path: '/code',
  //     name: 'Код подтверждения',
  //     meta: {layout: "auth"},
  //     component: () => import('../views/auth/Code')
  // },
  {
    path: "/forgot",
    name: "Забыли пароль",
    meta: { layout: "auth" },
    component: () => import("../views/auth/Forgot"),
  },
  {
    path: "/forgot-code",
    name: "Код подтверждения ",
    meta: { layout: "auth" },
    component: () => import("../views/auth/ForgotCode"),
  },
  {
    path: "/new-password",
    name: "Новый пароль",
    meta: { layout: "auth" },
    component: () => import("../views/auth/NewPassword"),
  },
  // CART DISABLED FOR EMPLOYEE TRAINING - Redirect to home
  {
    path: "/cart",
    redirect: "/",
  },
  {
    path: "/checkout",
    redirect: "/",
  },
  {
    path: "/contact",
    name: "Contact",
    meta: { layout: "main" },
    component: () => import("../views/Contact"),
  },
  {
    path: "/bonus",
    name: "Bonus",
    meta: { layout: "user" },
    component: () => import("../views/user/Bonus"),
  },
  {
    path: "/certificates",
    name: "Certificates",
    meta: { layout: "user" },
    component: () => import("../views/user/Certificates"),
  },
  {
    path: "/check/:hash",
    name: "Check course certificate",
    meta: { layout: "main" },
    component: () => import("../views/CheckCertificateInfo"),
  },
  {
    path: "/promo-codes",
    name: "Promo codes",
    meta: { layout: "user" },
    component: () => import("../views/user/Promocodes"),
  },
  {
    path: "/my-card",
    name: "My card",
    meta: { layout: "user" },
    component: () => import("../views/user/MyCard"),
  },
  {
    path: "/desires",
    name: "Desires",
    meta: { layout: "user" },
    component: () => import("../views/user/Desires"),
  },
  {
    path: "/invite",
    name: "Invite",
    meta: { layout: "user" },
    component: () => import("../views/user/Invite"),
  },
  {
    path: "/notification",
    name: "Notification",
    meta: { layout: "user" },
    component: () => import("../views/user/Notification"),
  },
  {
    path: "/profile",
    name: "Profile",
    meta: { layout: "user" },
    component: () => import("../views/user/Profile"),
  },
  {
    path: "/user",
    name: "User",
    meta: { layout: "user" },
    component: () => import("../views/user/User"),
  },
  {
    path: "/certified/:id",
    name: "Certified",
    meta: { layout: "main" },
    component: () => import("../views/course/Certified"),
  },
  {
    path: "/certified-courses",
    name: "Certified Course",
    meta: { layout: "main" },
    component: () => import("../views/course/CertifiedCourse"),
  },
  {
    path: "/test/:slug",
    meta: { layout: "main", requiresAuth: true },
    component: () => import("../views/course/ProctoredTest.vue"),
  },
  {
    path: "/certificated-test/:slug",
    meta: { layout: "main", requiresAuth: true },
    component: () => import("../views/course/ProctoredCertificatedTest.vue"),
  },
  {
    path: "/news/:slug",
    name: "News",
    meta: { layout: "main" },
    component: () => import("../views/NewsSingle"),
  },
  {
    path: "*",
    name: "404",
    meta: { layout: "main" },
    component: () => import("../views/404"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('access')) {
      next('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});
router.afterEach(() => {
  document.body.style.opacity = 0;
  setTimeout(() => {
    document.body.style.opacity = 1;
  }, 300);
});
export default router;
